import { withInstall } from '@pc-fx-framework/utils/with-install'
import VScrollingListChart from './src/index.vue'

export const FxVScrollingListChart = withInstall(VScrollingListChart)
export default FxVScrollingListChart

export * from './src/types'
